<template>
	<div class="container-xl px-4">
		<ProfileNav />
		<div class="card card-header-actions mb-4">
			<div class="card-header">Предстоящие события</div>
			<div class="card-body px-0" v-if="entries.coming.length > 0">
				<div
					v-for="(entry, index) in entries.coming"
					:key="index"
					v-show="entry.event.published"
					:class="index != Object.keys(entries.coming).length - 1 ? 'border-bottom' : ''"
					class="d-flex flex-column flex-sm-row align-items-center justify-content-between px-4 py-3"
				>
					<div class="d-flex align-items-center">
						<div>
							<router-link :to="{ name: 'event-details', params: { id: entry.event.shortId } }" target="_blank">
								{{ entry.event.title }}
							</router-link>
							<div class="text-xs text-muted">Начало: {{ entry.event.dateStart | moment("DD.MM.YYYY HH:mm") }}</div>
							<div class="text-xs text-muted" v-if="entry.event.dateEnd">
								Окончание: {{ entry.event.dateEnd | moment("DD.MM.YYYY HH:mm") }}
							</div>
						</div>
					</div>
					<div class="small">
						<a v-if="entry.status == 'joined'" class="text-muted" @click="leaveEvent(entry)">Отменить участие</a>
						<span v-if="entry.status == 'left'" class="badge bg-warning text-dark">Вы отозвали свое участие</span>
					</div>
				</div>
			</div>
			<div v-else class="d-flex align-items-center justify-content-center px-4 py-3">
				<div class="d-flex align-items-center">
					<router-link :to="{ name: 'events' }" class="btn btn-primary"> Найти событие </router-link>
				</div>
			</div>
		</div>

		<div class="card card-header-actions mb-4" v-if="entries.past.length > 0">
			<div class="card-header">Завершенные события</div>
			<div class="card-body px-0">
				<template v-for="(entry, index) in entries.past">
					<div
						:key="index"
						:class="index != Object.keys(entries.past).length - 1 ? 'border-bottom' : ''"
						v-show="entry.event.published"
						class="d-flex flex-column flex-sm-row align-items-center justify-content-between px-4 py-3"
					>
						<div class="d-flex align-items-center">
							<div>
								<router-link :to="{ name: 'event-details', params: { id: entry.event.shortId } }" target="_blank">
									{{ entry.event.title }}
								</router-link>
								<div class="text-xs text-muted">
									Завершено
									{{ entry.event.dateEnd ? entry.event.dateEnd : entry.event.dateStart | moment("DD.MM.YYYY HH:mm") }}
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileNav from "../profile/TopNav.vue";
// import EventDataService from "../../services/event.service";
import ParticipantsDataService from "../../services/participants.service";
import moment from "moment";

export default {
	name: "my-events",
	metaInfo: {
		title: "Мои события",
		meta: [{ name: "description", content: "Мои события" }],
	},
	components: { ProfileNav },
	data() {
		return {
			entries: {
				all: [],
				past: [],
				coming: [],
			},
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.auth.user;
		},
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},
	methods: {
		async getUserEvents() {
			let user = this.currentUser;
			let entries = null;
			try {
				entries = await ParticipantsDataService.getUserEvents(user);

				if (entries.data.length > 0) {
					let today = moment();
					entries.data.forEach((entry) => {
						let eventDateEnd = entry.event.dateEnd ? moment(entry.event.dateEnd) : moment(entry.event.dateStart);

						let endDays = today.diff(eventDateEnd, "days");

						if (endDays > 0) {
							this.entries.past.push(entry);
						} else {
							this.entries.coming.push(entry);
						}
						this.entries.all.push(entry);
					});
				}
			} catch (err) {
				if ([401, 403].includes(err.response.status)) {
					this.$store.commit("auth/LOGOUT");
					alert("Сессия истекла. Войдите в ваш аккаунт");
				} else {
					console.error(err);
					console.log(err.response.status);
				}
			}
		},
		async leaveEvent(entry) {
			let user = this.currentUser;
			let eventId = entry.event._id;

			if (this.loggedIn && user.id && eventId) {
				let eventParticipation = null;

				if (confirm("Вы уверены, что хотите отменить участие в событии?")) {
					try {
						eventParticipation = await ParticipantsDataService.userLeaveEvent(eventId, user.id);
						console.log(eventParticipation);
						if (eventParticipation.data && eventParticipation.data.status === "left") {
							alert("Регистрация отменена");
							this.$router.go();
						}
					} catch (err) {
						if ([401, 403].includes(err.response.status)) {
							this.$store.commit("auth/LOGOUT");
							alert("Сессия истекла. Войдите в ваш аккаунт");
						} else {
							console.error(err);
							console.log(err.response.status);
						}
					}
				}
			}
		},
	},
	async created() {
		await this.$store.dispatch("user/getProfile");
		this.userProfile = this.userProfileState;

		if (!this.loggedIn || !this.currentUser) {
			this.$store.dispatch("auth/logout");
			this.$router.push("/login");
		}
	},
	async mounted() {
		this.getUserEvents();
	},
};
</script>

<style scoped>
.card {
	box-shadow: 0 0.15rem 1.75rem 0 rgb(33 40 50 / 15%);
}
.card .card-header {
	font-weight: 500;
}
.card-header:first-child {
	border-radius: 0.35rem 0.35rem 0 0;
}
.card-header {
	padding: 1rem 1.35rem;
}
.form-control,
.dataTable-input {
	display: block;
	width: 100%;
	padding: 0.875rem 1.125rem;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1;
	color: #69707a;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #c5ccd6;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.35rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
